import { isNestedItemData, type OrderPreference, type TNestedItemData } from '../dnd-data';
import { useUpdateNestedItemOrder } from '../nested-item-reordering/useUpdateNestedItemOrder';

import { type AnalyticsEventHandler, useDropTarget } from './index';

type UseNestedItemDropTargetArgs = {
	currentItems: TNestedItemData[];
	currentOrder: OrderPreference;
	entityAri: string;
	fireAnalyticsEvent?: AnalyticsEventHandler;
	group: string;
	ownerAri: string;
};

type UseNestedItemDropTarget = (args: UseNestedItemDropTargetArgs) => {
	ref: React.RefObject<HTMLDivElement>;
	state: 'idle' | 'is-over' | undefined;
};

export const useNestedItemDropTarget: UseNestedItemDropTarget = ({
	entityAri,
	ownerAri,
	currentItems,
	currentOrder,
	fireAnalyticsEvent,
	group,
}) => {
	const updateOrder = useUpdateNestedItemOrder();
	return useDropTarget<TNestedItemData>({
		canDrop: (dropData): dropData is TNestedItemData => {
			return (
				isNestedItemData(dropData) && dropData.entityAri === entityAri && dropData.group === group
			);
		},
		isDraggableItem: (dragData) => {
			return (
				isNestedItemData(dragData) && dragData.entityAri === entityAri && dragData.group === group
			);
		},
		performDropOperation: (operation, dragging, dropTargetData) => {
			updateOrder({
				operation,
				entityAri,
				ownerAri,
				targetItemId: dragging.menuItemId,
				relativeItemId: dropTargetData.menuItemId,
				currentOrder,
				currentItems,
				getItemId: (item) => (item as TNestedItemData).menuItemId,
				fireAnalyticsEvent,
			});
		},
	});
};
